module.exports = __webpack_public_path__ + "d72032b09a9261cb6510e187e6e356b9.png";